import script from "./WorkbookPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkbookPage.vue?vue&type=script&setup=true&lang=ts"

import "./WorkbookPage.vue?vue&type=style&index=0&id=583b6cc1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583b6cc1"]])

export default __exports__